module.exports = __webpack_public_path__ + "static/media/21ECLAC23.ac83d291.jpg";